// @flow
import Participate from 'components/hub/Participate';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { Props } from 'components/hub/Participate';

export default connect(
  (state: StateType): Props => ({
    title: state.cardState.titre_liste_cards,
    cards: state.cardState.liste_cards_home
  })
)(Participate);
